import { put, call, takeEvery, select } from "redux-saga/effects";

import * as apis from "../../network/apis/trainingWorkingSlots";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { getDailyAndMonthlyReportsRequests } from "../TimeSheet/actions";

const buildTrainingRefetchParams = (payload, locale) => {
  if (payload.refetchParams) {
    return {
      ...payload.refetchParams,
      locale: payload.refetchParams.locale ?? locale,
    };
  }

  return {
    page: -1,
    event_id: payload.data?.event_id ?? payload.event_id ?? payload.eventId,
    user_id: payload.data?.user_id ?? payload.user_id ?? payload.userId,
    locale,
  };
};

function* getTrainingWorkingSlotsListSaga({ payload }) {
  try {
    const locale = payload.locale ?? (yield select((s) => s.locale?.lang));
    const params = { ...payload, locale };
    const response = yield call(apis.getTrainingWorkingSlotsList, params);

    const data = response?.data?.data ?? [];
    const headers = response?.headers;
    const meta = {
      currentPage: headers?.["current-page"] ? +headers["current-page"] : 1,
      count: headers?.["total-count"] ? +headers["total-count"] : data.length,
      pages: headers?.["total-pages"] ? +headers["total-pages"] : 1,
    };

    yield put(
      actions.getTrainingWorkingSlotsResponse({
        list: data,
        meta,
      })
    );

    if (
      headers?.["current-page"] &&
      headers?.["total-pages"] &&
      +headers["current-page"] > +headers["total-pages"]
    ) {
      yield put(
        actions.getTrainingWorkingSlotsRequest({
          ...params,
          page: +headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* addTrainingWorkingSlotSaga({ payload }) {
  const { onSuccess, onError, ...requestPayload } = payload;

  try {
    yield call(apis.addTrainingWorkingSlot, requestPayload);
    yield call(showSuccessMsg, "addedSuccessfully");
    const locale = yield select((s) => s.locale?.lang);
    yield put(
      actions.getTrainingWorkingSlotsRequest(
        buildTrainingRefetchParams(requestPayload, locale),
      ),
    );
    if (requestPayload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(requestPayload.refetchWorkingLogs));
    }
    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (error) {
    if (typeof onError === "function") {
      onError(error);
    }
    if (error?.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* editTrainingWorkingSlotSaga({ payload }) {
  const { onSuccess, onError, ...requestPayload } = payload;

  try {
    yield call(apis.editTrainingWorkingSlot, requestPayload);
    yield call(showSuccessMsg, "updatedSuccessfully");
    const locale = yield select((s) => s.locale?.lang);
    yield put(
      actions.getTrainingWorkingSlotsRequest(
        buildTrainingRefetchParams(requestPayload, locale),
      ),
    );
    if (requestPayload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(requestPayload.refetchWorkingLogs));
    }
    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    if (err?.response) {
      yield call(showErrorMsg, err.response?.data?.message);
    }
  }
}

function* deleteTrainingWorkingSlotSaga({ payload }) {
  try {
    yield call(apis.deleteTrainingWorkingSlot, payload);
    yield showSuccessMsg("deletedSuccessfully");
    const locale = yield select((s) => s.locale?.lang);
    yield put(
      actions.getTrainingWorkingSlotsRequest(buildTrainingRefetchParams(payload, locale))
    );
    if (payload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(payload.refetchWorkingLogs));
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

export default function* TrainingWorkingSlotsSaga() {
  yield takeEvery(
    types.GET_TRAINING_WORKING_SLOTS_REQUEST,
    getTrainingWorkingSlotsListSaga
  );
  yield takeEvery(types.ADD_TRAINING_WORKING_SLOT, addTrainingWorkingSlotSaga);
  yield takeEvery(
    types.EDIT_TRAINING_WORKING_SLOT_REQUEST,
    editTrainingWorkingSlotSaga
  );
  yield takeEvery(
    types.DELETE_TRAINING_WORKING_SLOT_REQUEST,
    deleteTrainingWorkingSlotSaga
  );
}
